<template>
  <div>
    <table-layout
      pkField="id"
      :selected.sync="selected"
      :isAdmin="isAdmin"
      :loading="serversLoading"
      :items="uISettings"
      :columns="columns"
      :addOptions="elementTypes"
      :uploadZipBlue="'ui_settings'"
      @uploaded="refetch"
      @click:addNew="addUISetting"
    >
      <template #actions>
        <b-dropdown-item @click="changeAccess(true)" aria-role="listitem">{{
          $t('ui_settings.makePublic')
        }}</b-dropdown-item>
        <b-dropdown-item @click="changeAccess(false)" aria-role="listitem">{{
          $t('ui_settings.makePrivate')
        }}</b-dropdown-item>
        <b-dropdown-item @click="openDialogRemove" aria-role="listitem">{{ $t('ui_settings.delete') }}</b-dropdown-item>
      </template>
    </table-layout>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import TableLayout from '@/layout/TableLayout'

const { mapState: mapUserState } = createNamespacedHelpers('general')

export default {
  name: 'UISettings',
  components: {
    TableLayout
  },
  created() {
    this.refetch()
    this.getTypes()
  },
  computed: {
    ...mapUserState({
      role: state => state.user.role
    }),
    isAdmin() {
      return this.role === 'ADMIN'
    }
  },
  data() {
    return {
      uISettings: [],
      elementTypes: [],
      serversLoading: false,
      uISettingsTypes: [],
      columns: [
        {
          sortable: true,
          field: 'name',
          label: 'columns.element_name',
          route: {
            name: 'edit_ui_element',
            params: [
              {
                name: 'ui_element_id',
                field: 'id'
              }
            ],
            isSpecialRowsLinks: true,
            specialField: 'type',
            specialValue: 'dashboard',
            specialName: 'edit_dashboard',
            specialParams: [
              {
                name: 'dashboard_id',
                field: 'id'
              }
            ]
          }
        },
        {
          sortable: true,
          field: 'type',
          label: 'columns.element_type'
        },
        {
          sortable: true,
          field: 'usage',
          label: 'columns.usage'
        },
        {
          sortable: true,
          field: 'access',
          label: 'columns.access'
        },
        {
          sortable: true,
          field: 'created_by',
          label: 'columns.created_by'
        }
      ],
      selected: []
    }
  },
  methods: {
    addUISetting(type) {
      this.$router.push({
        name: 'add_ui_element',
        query: { type: type }
      })
    },
    refetch() {
      if (!this.serversLoading) {
        const url = `${process.env.VUE_APP_API_ENDPOINT || window.location.origin}/api/ui_settings`
        this.serversLoading = true
        fetch(url, {
          method: 'GET',
          credentials: 'include'
        })
          .then(res => {
            if (!res.ok) {
              throw res.json()
            }
            return res.json()
          })
          .then(data => {
            this.uISettings = data
          })
          .catch(error =>
            error.then(data => {
              this.$notify({
                message: JSON.parse(data.message).message,
                type: 'danger'
              })
            })
          )
          .finally(() => {
            this.serversLoading = false
          })
      }
    },
    getTypes() {
      const url = `${process.env.VUE_APP_API_ENDPOINT || window.location.origin}/api/ui_settings/types`
      fetch(url, {
        method: 'GET',
        credentials: 'include'
      })
        .then(res => {
          if (!res.ok) {
            throw res.json()
          }
          return res.json()
        })
        .then(data => {
          this.elementTypes = data
        })
        .catch(error =>
          error.then(data => {
            this.$notify({
              message: JSON.parse(data.message).message,
              type: 'danger'
            })
          })
        )
    },
    deleteUISettings(uISetting_ids, msg) {
      const url = `${process.env.VUE_APP_API_ENDPOINT || window.location.origin}/api/ui_settings/delete`
      return fetch(url, {
        credentials: 'include',
        body: JSON.stringify({
          ui_element_ids: uISetting_ids
        }),
        method: 'POST'
      })
        .then(res => {
          if (!res.ok) {
            throw res.json()
          }
          return res.json()
        })
        .then(() => {
          this.$notify({
            message: this.$t('notification.removed', {
              msg: msg
            }),
            type: 'success'
          })
        })
        .catch(error =>
          error.then(data => {
            this.$notify({
              message: JSON.parse(data.message).message,
              type: 'danger'
            })
          })
        )
    },
    openDialogRemove() {
      if (!this.selected.length) {
        this.$notify({
          message: this.$t('notification.unselected'),
          type: 'danger'
        })
        return
      }
      const indexSet = new Set(this.selected)
      const uISettings = this.uISettings
        .filter(value => {
          return indexSet.has(value.id)
        })
        .map(d => {
          return d['name']
        })
      const msg = uISettings
        .map(d => {
          return d
        })
        .join(', ')

      this.$dialog.confirm({
        message: `${this.$t('confirm.remove', {
          msg: msg
        })}?`,
        onConfirm: () => {
          this.serversLoading = true
          this.deleteUISettings(this.selected, msg).finally(() => {
            this.serversLoading = false
            this.refetch()
          })
        }
      })
    },
    changeAccess(access) {
      if (!this.selected.length) {
        this.$notify({
          message: this.$t('notification.unselected'),
          type: 'danger'
        })
        return
      }

      this.serversLoading = true
      const url = `${process.env.VUE_APP_API_ENDPOINT || window.location.origin}/api/ui_settings/change_access`
      return fetch(url, {
        credentials: 'include',
        body: JSON.stringify({
          ui_element_ids: this.selected,
          access: access
        }),
        method: 'POST'
      })
        .then(res => {
          if (!res.ok) {
            throw res.json()
          }
        })
        .catch(error =>
          error.then(data => {
            this.$notify({
              message: JSON.parse(data.message).message,
              type: 'danger'
            })
          })
        )
        .finally(() => {
          this.serversLoading = false
          this.refetch()
        })
    }
  }
}
</script>

<style scoped lang="scss">
.table {
  width: 100%;
}
</style>
